var map = {
	"./archived": 10,
	"./archived.png": 10,
	"./back_to_top": 11,
	"./back_to_top.png": 11,
	"./banner1": 12,
	"./banner1.jpg": 12,
	"./bin": 13,
	"./bin.png": 13,
	"./bin_wt": 14,
	"./bin_wt.png": 14,
	"./blanc_img": 15,
	"./blanc_img.jpg": 15,
	"./cherry": 16,
	"./cherry.svg": 16,
	"./cherry_bkg": 17,
	"./cherry_bkg.jpg": 17,
	"./down": 18,
	"./down.png": 18,
	"./dublicate": 19,
	"./dublicate.png": 19,
	"./dublicate_wt": 20,
	"./dublicate_wt.png": 20,
	"./edit": 21,
	"./edit.png": 21,
	"./edit_wt": 22,
	"./edit_wt.png": 22,
	"./entrance": 23,
	"./entrance.png": 23,
	"./exit": 24,
	"./exit.png": 24,
	"./favicon.ico": 51,
	"./items": 25,
	"./items.png": 25,
	"./letter": 26,
	"./letter.png": 26,
	"./logo": 27,
	"./logo.jpg": 27,
	"./logo_big": 28,
	"./logo_big.png": 28,
	"./menu-4x": 29,
	"./menu-4x.png": 29,
	"./order": 30,
	"./order.png": 30,
	"./row1_img1": 31,
	"./row1_img1.jpg": 31,
	"./row1_img2": 32,
	"./row1_img2.jpg": 32,
	"./row2_img": 33,
	"./row2_img.jpg": 33,
	"./row3_img1": 34,
	"./row3_img1.jpg": 34,
	"./row3_img2": 35,
	"./row3_img2.jpg": 35,
	"./row3_img3": 36,
	"./row3_img3.jpg": 36,
	"./row3_img4": 37,
	"./row3_img4.jpg": 37,
	"./row4_img": 38,
	"./row4_img.jpg": 38,
	"./shopping-cart": 39,
	"./shopping-cart.png": 39,
	"./shopping-cart_wt": 40,
	"./shopping-cart_wt.png": 40,
	"./spinner": 41,
	"./spinner.gif": 41,
	"./up": 42,
	"./up.png": 42
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50;